<template>
  <div class="text-editor center-ag-grid-editor">
    <RInput ref="input" v-model="value" no-feedback-icon no-hint no-label on-clear="focus" />
  </div>
</template>

<script>
export default {
  data: () => ({
    value: null
  }),

  created() {
    this.value = this.params.value
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.input.focus()
      this.$refs.input.select()
    })
  },

  methods: {
    getValue() {
      return this.value
    }
  }
}
</script>

<style lang="scss" scoped>
.text-editor .r-input {
  width: 100%;
}
</style>
